module.exports = __webpack_public_path__ + "img/qualityPlatform_数据全面丰富.1b4aeb22.png";